import { makeStyles, shorthands } from '@fluentui/react-components';

export const useImageCardContainerStyle = makeStyles({
  cardContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    ...shorthands.gap('8px'),
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
  },
});
